import styled from 'styled-components'

import { type ShopInfo } from '~/features/general-participation/types/general-participation'
import ExclamationMark from '~/shared/assets/icons/ExclamationMark'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

type Props = {
  data: ShopInfo
}

function Shop({ data }: Props) {
  const { shop, open_time, ticket_type, ticket_usage, buy_method } = data

  return (
    <Wrapper>
      <Title>
        일러스타 페스 일반 참가 입장권 예매 방법/이용 가능 시간 안내
      </Title>
      <TagBox className="center">
        <Tag $size="md" $variant="gray">
          입장권 예매처
        </Tag>
        <Desc>{shop}</Desc>
      </TagBox>
      <TagBox className="center">
        <Tag $size="md" $variant="gray">
          예매 방법
        </Tag>
        <Desc>{buy_method}</Desc>
      </TagBox>
      <TagBox>
        <Tag $size="md" $variant="gray">
          입장권 종류
        </Tag>
        <VerticalBox>
          <Desc>{ticket_type}</Desc>
          <CautionBox>
            <ExclamationMark />
            <CautionBoxDesc>
              티켓 관련 자세한 내용은 티켓 구매 화면에서 확인해 주세요.
            </CautionBoxDesc>
          </CautionBox>
        </VerticalBox>
      </TagBox>
      <TagBox className="center">
        <Tag $size="md" $variant="gray">
          행사 운영시간
        </Tag>
        <Desc>{open_time}</Desc>
      </TagBox>
      <TagBox className="center">
        <Tag $size="md" $variant="gray">
          티켓 사용
        </Tag>
        <Desc>{ticket_usage}</Desc>
      </TagBox>
    </Wrapper>
  )
}

export default Shop

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  height: auto;
  padding: 36px 24px;

  font-size: 18px;
  line-height: 25px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`
const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;

  @media ${theme.device.medium} {
    font-size: 21px;
  }
`

const TagBox = styled.div`
  display: flex;
  gap: 36px;
  white-space: pre-line;

  &.center {
    align-items: center;

    @media ${theme.device.medium} {
      align-items: start;
    }
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`

const Desc = styled.p`
  font-size: 18px;
  line-height: 25px;
  word-wrap: break-word;

  @media ${theme.device.medium} {
    font-size: 15px;
    line-height: 21px;
  }
`

const VerticalBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const CautionBox = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  width: fit-content;
  height: 25px;
  padding: 10px;

  background-color: #eaebeb;
  border-radius: 12px;

  @media ${theme.device.medium} {
    height: 62px;
    padding: 10px;
  }
`

const CautionBoxDesc = styled.p`
  font-size: 18px;
  line-height: 25px;
  word-wrap: break-word;

  @media ${theme.device.medium} {
    font-size: 15px;
    line-height: 21px;
  }
`
